import { render } from "./ShowMandeh.vue?vue&type=template&id=c5f56db0"
import script from "./ShowMandeh.vue?vue&type=script&lang=js"
export * from "./ShowMandeh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__